import { useComponentVariant } from '@/hooks/theme/useComponentVariant';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import { ComponentTypeId } from '@starsoft/common/models/setting/layout/component/type/types.enum';
import { memo, useEffect } from 'react';
import { useCountUp } from 'use-count-up';
import GameCountdownContent from './Content';
import { GameCountdownProps } from './props';
import styles from './styles.module.scss';

function GameCountdown({ countdown }: GameCountdownProps) {
  const version: string = useComponentVariant(ComponentTypeId.GameCountdown);

  const isVisible: boolean = countdown?.isPositive?.();

  const { value: countdownInterpolated, reset: resetCountdown } = useCountUp({
    start: (countdown?.toNumber?.() ?? 0) + 0.2,
    end: countdown?.toNumber?.() ?? 0,
    isCounting: isVisible,
    decimalPlaces: 2,
    duration: 0.2,
  });
  const progress: number = (Number(countdownInterpolated) / 10) * 100;

  function resetInterpolators() {
    resetCountdown();
  }

  useEffect(resetInterpolators, [countdown, isVisible, resetCountdown]);

  return (
    <div
      className={`${styles.container} ${version === SettingLayoutComponentId.GameCountdownV2?.toString() ? styles['container--v2'] : ''} ${isVisible ? styles['container--visible'] : ''}`}
    >
      <GameCountdownContent
        progress={progress}
        countdown={countdown}
        isVisible={isVisible}
        countdownInterpolated={countdownInterpolated as string}
      />
    </div>
  );
}
export default memo(GameCountdown);
